import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../../environments/environment';

export const authConfig: AuthConfig = {
  issuer: environment.identityAuthority,

  clientId: environment.clientId,
  responseType: 'code', // IMPORTANT (PKCE flow)

  redirectUri: window.location.origin + '/auth/callback',
  postLogoutRedirectUri: window.location.origin + '/auth/logout',

  scope: environment.scope,

  showDebugInformation: true,

  strictDiscoveryDocumentValidation: false,

  requireHttps: true,
};